import * as _ from 'lodash';
import initialState from './initialState';
import { types } from './actions';
import { ROUTE } from '../../../../HelperMethods/constants';

export default function areaSetupReducer(state = initialState, action) {
  switch (action.type) {
    case types.ALL_ASSET_ATTRIBUTES_LOADED: {
      const allAttributes = [
        ..._.uniqBy(action.data, 'attributeName'),
        { attributeName: ROUTE, attributeDisplayName: ROUTE },
      ];
      return {
        ...state,
        allAssetAttributes: allAttributes.map((attribute) => ({
          key: attribute.attributeName,
          value: attribute.attributeName,
          text: attribute.attributeDisplayName,
        })),
      };
    }
    case types.ALL_ROUTES_LOADED: {
      return {
        ...state,
        allRoutes: {
          isLoading: false,
          value: action.data.map((route) => ({
            key: route.id,
            value: route.id,
            text: route.name,
          })),
        },
      };
    }
    default:
      return state;
  }
}
